import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TIndirectTaxCustomerGetSubmissionResponse } from './types';

export function useIndirectTaxCustomerSubmissions(
  corporationId: number,
  customerId: string
) {
  const { data, error, isLoading, mutate } = useSWR<
    TIndirectTaxCustomerGetSubmissionResponse[]
  >(
    corporationId && customerId
      ? `portal/sellers/${corporationId}/customers/${customerId}/submissions`
      : null,
    SWRFetcher({ method: 'GET' }, undefined)
  );

  return {
    submissions: data,
    isLoading,
    error,
    mutate,
  };
}
